// 소개 링크 액션(rpc) — 고객 상세의 소개 링크 카드가 쓴다.
import { rpc } from "@/api/client";

export const createReferralLink = (input: unknown) => rpc("referral/actions/createReferralLink", input);

export const setReferralLinkActive = (input: unknown) => rpc("referral/actions/setReferralLinkActive", input);
